import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Growth Hackeng — Email Marketing & Growth Systems for Creators',
  description = 'Turn your email list into a predictable revenue engine. Email marketing & automation for creators with 10K+ lists. Kit.com · ActiveCampaign · ManyChat expert. 5.0 on Upwork with 60+ creators shipped.',
  keywords = 'email marketing, Kit.com expert, ActiveCampaign specialist, email automation, deliverability optimization, newsletter monetization, ManyChat, email funnels, growth hacking, Growth Hackeng, Akash Tiwari',
  ogImage = 'https://growthhackeng.com/og-image.png',
  ogType = 'website',
  canonical,
  noindex = false
}) => {
  const siteUrl = 'https://growthhackeng.com';
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : `${siteUrl}/`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow" />}
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content="Growth Hackeng" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullCanonical} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      <meta property="twitter:image:alt" content={title} />
    </Helmet>
  );
};

export default SEO;
